<template>
    <v-container>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <v-layout class="justify-content-center row mt-5" v-if="isDesktop() && alertLoader" style="margin-bottom: 10%">
            <div id="notfound">
                <div class="notfound">
                    <div class="notfound-404">
                        <h1>Oops!</h1>
                         <h2>{{ $t('magic_link_page.error_message') }}</h2>
                    </div>
                    <a href="/">{{ $t('magic_link_page.bouton_home_label') }}</a>
                </div>
            </div>
        </v-layout>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      ================ -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <v-layout class="justify-content-center row" v-if="isMobile() && alertLoader" style="margin-bottom: 30%">
            <div id="notfound">
                <div class="notfound">
                    <div class="notfound-404">
                        <h1>Oops!</h1>
                        <h2 class="ml-3 mr-3">{{ $t('magic_link_page.error_message') }}</h2>
                    </div>
                    <a href="/">{{ $t('magic_link_page.bouton_home_label') }}</a>
                </div>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
'use strict';
import Api from './../../services/Api'

export default {
    data() {
        return {
            alertLoader: false,
            token: null,
            loading: true,
            error: null,
            errorMsg: "",
            ToastTabError: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'error'
            }, // Customized options for error toast
        };
    },

    methods:{
        goHome(){
            console.log("go home")
            this.$router.push({ name: 'Home' });
        },
        isMobile: function () {
                if (screen.width <= 760) {
                    return true
                } else {
                    return false
                }
            },
            isDesktop: function () {
                if (screen.width > 760) {
                    return true
                } else {
                    return false
                }
            }
    },

    async mounted() {
        this.token = this.$route.query.token;
        if (!this.token) {
            this.error = "Lien invalide.";
            this.loading = false;
            return;
        }
        Api().post("user/magiclink/auth", { token: this.token })
            .then(async (result) => {
                await this.$store.dispatch('setToken', result.data)
                await this.$store.dispatch('setUser', result.data)
                await this.$router.push({ name: 'Home' });
            }).catch((err) => {
                this.alertLoader = true
                this.errorMsg = this.$t('magic_link_page.error_message')
                //"Lien de connexion expiré ou inexistant !"
            })
    },
};
</script>

<style lang="less">
.georgia {
        font-family: Georgia !important;
    }

    #notfound {
        position: relative;
        height: 50vh;
    }

    #notfound .notfound {
        position: relative;
        left: 50%;
        top: 60%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .notfound {
        max-width: 520px;
        width: 100%;
        line-height: 1.4;
        text-align: center;
    }

    .notfound .notfound-404 {
        position: relative;
        height: 200px;
        margin: 0px auto 20px;
        z-index: -1;
    }

    .notfound .notfound-404 h1 {
        font-family: 'Montserrat', sans-serif;
        font-size: 236px;
        font-weight: 200;
        margin: 0px;
        color: #ffa409;
        text-transform: uppercase;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .notfound .notfound-404 h2 {
        font-family: 'Montserrat', sans-serif;
        font-size: 20px;
        font-weight: 300;
        text-transform: uppercase;
        color: #211b19;
        background: #fff;
        padding: 10px 5px;
        margin: auto;
        display: inline-block;
        position: relative;
        bottom: 0px;
        top: 73%;
        left: 0;
        right: 0;
    }

    .notfound a {
        font-family: 'Montserrat', sans-serif;
        display: inline-block;
        font-weight: 500;
        text-decoration: none;
        color: #ffa409;
        text-transform: uppercase;
        padding: 13px 23px;
        background: #fff;
        font-size: 18px;
        -webkit-transition: 0.2s all;
        transition: 0.2s all;
    }

    .notfound a:hover {
        color: #fff;
        background: #ffa409;
        border-radius: 30px !important;
    }

    @media only screen and (max-width: 767px) {
        .notfound .notfound-404 h1 {
            font-size: 148px;
        }
    }

    @media only screen and (max-width: 480px) {
        .notfound .notfound-404 {
            height: 148px;
            margin: 0px auto 10px;
        }

        .notfound .notfound-404 h1 {
            font-size: 86px;
        }

        .notfound .notfound-404 h2 {
            font-size: 16px;
        }

        .notfound a {
            padding: 7px 15px;
            font-size: 14px;
        }
    }

    * {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
</style>
